import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, XCircle, MessageCircle, Gift } from "lucide-react";
import { tr } from "../lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GiftSuccessPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const code = params.get("voucher");
  const [lang] = useState(() => localStorage.getItem("lang") || "it");
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    let cancelled = false, attempts = 0;
    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await axios.get(`${API}/gifts/payments/status/${sessionId}`);
        if (data.payment_status === "paid" && data.code) { nav(`/regalo/${data.code}`, { replace: true }); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState({ loading: false, failed: true }); return; }
      } catch { /* transient */ }
      if (++attempts > 30) { setState({ loading: false, timeout: true }); return; }
      setTimeout(poll, 2000);
    };
    if (sessionId) poll();
    else if (code) axios.get(`${API}/gifts/voucher/${code}`).then((r) => setState({ loading: false, voucher: r.data })).catch(() => setState({ loading: false, failed: true }));
    else setState({ loading: false, failed: true });
    return () => { cancelled = true; };
  }, [sessionId, code, nav]);

  if (state.loading) return <div className="min-h-screen bg-[#faf3ee] flex flex-col items-center justify-center gap-3 text-[#4a1c17]"><Loader2 className="h-8 w-8 animate-spin" /><div className="text-sm">{tr({ it: "Confermiamo il pagamento…", en: "Confirming payment…" }, lang)}</div></div>;
  if (state.voucher) {
    const v = state.voucher;
    return (
      <div className="min-h-screen bg-[#faf3ee] flex flex-col items-center justify-center gap-4 px-6 text-center" data-testid="gift-inhouse-success">
        <div className="h-16 w-16 rounded-full bg-[#C48B31] text-white flex items-center justify-center shadow-lg"><Gift className="h-8 w-8" /></div>
        <h1 className="font-serif text-3xl font-bold text-[#2b1410]">{tr({ it: "Regalo pronto, manca solo il pagamento", en: "Gift ready, only payment left" }, lang)}</h1>
        <p className="max-w-md text-[#7c5a4e] text-sm">{tr({ it: `Codice ${v.code}. Scrivici su WhatsApp: appena riceviamo il pagamento in struttura attiviamo il voucher e te lo inviamo.`, en: `Code ${v.code}. Message us on WhatsApp: once we receive payment on site we activate the voucher and send it to you.` }, lang)}</p>
        {v.wa_pay_url && <a href={v.wa_pay_url} target="_blank" rel="noreferrer" data-testid="gift-inhouse-wa" className="inline-flex items-center gap-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-4 text-lg font-semibold shadow-md animate-pulse"><MessageCircle className="h-5 w-5" /> {tr({ it: "Scrivici su WhatsApp", en: "Message us on WhatsApp" }, lang)}</a>}
        <button onClick={() => nav(`/regalo/${v.code}`)} data-testid="gift-inhouse-view" className="text-sm text-[#4a1c17] underline underline-offset-4">{tr({ it: "Guarda l'anteprima del voucher", en: "Preview the voucher" }, lang)}</button>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-[#faf3ee] flex flex-col items-center justify-center gap-3 px-6 text-center">
      <XCircle className="h-14 w-14 text-red-500" />
      <h1 className="font-serif text-2xl font-bold text-[#2b1410]">{tr({ it: state.timeout ? "Stiamo ancora aspettando la conferma" : "Pagamento non completato", en: state.timeout ? "Still waiting for confirmation" : "Payment not completed" }, lang)}</h1>
      <button onClick={() => nav("/regala")} className="rounded-full bg-[#4a1c17] text-[#f7ebdf] px-5 py-2.5 text-sm font-semibold">{tr({ it: "Torna al configuratore", en: "Back to the builder" }, lang)}</button>
    </div>
  );
}
